/**
 * ASSEL DIAMONDS - Optimized Consolidated Scripts
 * Replaces all scattered inline scripts with efficient, unified functionality
 */

(function() {
  'use strict';

  // ============================================
  // UTILITIES & HELPERS
  // ============================================
  
  const debounce = (fn, delay) => {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const throttle = (fn, limit) => {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        fn.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  };

  const isMobile = () => window.innerWidth <= 768;
  const isReadyToShip = () => /ready[-_]to[-_]ship/i.test(location.pathname);
  const isCartPage = () => location.pathname.indexOf('/cart') === 0;
  const isEducationPage = () => window.location.pathname.includes('/pages/education');

  // ============================================
  // CONFIGURATION
  // ============================================
  
  const CONFIG = {
    selectors: {
      priceContainer: '.price__container',
      salePrice: '.price__sale .price-item--sale',
      regularPrice: '.price__regular .price-item--regular',
      productCard: '#MainCollectionProductGrid .card, .collection .product-grid .card, .spf-product-card',
      cartItem: '.cart-item__details',
      swatch: '.mpg-swatch__option',
      customizeButton: '.customize-button',
      readyBadge: '.custom-badge.badge-ready, .badge-ready, .badge--ready',
      tidioChat: '#tidio-chat',
      tidioButton: '#tidio-chat-root button#button-body.chrome',
      faqIcons: '.Avada-Faq_FitIcon-Container',
      avadaButton: '.Avada-Launcher__ButtonCustom, .Avada-Faq_FitIcon-Container',
      deliveryIcon: '.delivery-icon-img',
      priceBlock: '#price-template--19541872869615__main'
    },
    classes: {
      withFrom: 'with-from',
      stickyBottom: 'sticky-bottom',
      stickyInline: 'sticky-inline',
      noHover: 'no-hover',
      detailsButton: 'details-button',
      freeResizingBadge: 'free-resizing-badge'
    }
  };

  // ============================================
  // CSS INJECTION (One-time)
  // ============================================
  
  function injectStyles() {
    if (document.getElementById('assel-optimized-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'assel-optimized-styles';
    style.textContent = `
      /* Price "From" prefix */
      .with-from { min-width: 0 !important; flex-shrink: 1 !important; }
      .with-from::before { content: 'From '; margin-right: 2px; }
      .price, .price__container { min-width: 0 !important; }

      /* Customize/Details button wrapper */
      .price-flex-wrapper {
        display: flex !important;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        gap: 12px;
      }
      .price-flex-wrapper .price__container {
        flex-grow: 1 !important;
        flex-shrink: 1 !important;
        min-width: 0 !important;
        width: auto !important;
        display: block !important;
      }
      .customize-button {
        background: none;
        color: #85745C;
        border: 1px solid #85745C;
        padding: 6px 14px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 0;
        cursor: pointer;
        transition: all 0.3s ease;
        white-space: nowrap;
        flex-shrink: 0;
      }
      .customize-button:hover { background-color: #f8f6f2; }
      .details-button { 
        display: inline-flex; 
        align-items: center; 
        justify-content: center; 
        text-decoration: none; 
      }

/* Sticky price bar */
#price-template--19541872869615__main {
  position: relative !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
  z-index: 1;
}
#price-template--19541872869615__main.sticky-bottom {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100vw !important;
  background: #fff;
  padding: 16px 24px !important;
  margin: 0 !important;
  border-top: 2px solid #0E0B0D !important;
  box-shadow: 0 -4px 20px rgba(0,0,0,.08);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  z-index: 1000;
}

/* Deposit notice styling */
.deposit-notice {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #0E0B0D !important;
  background-color: #f8f6f2 !important;
  border: 1.5px dashed #0E0B0D !important;
  padding: 6px 12px !important;
  border-radius: 4px !important;
  white-space: nowrap !important;
  margin-right: 0 !important;
}

#price-template--19541872869615__main .price {
  display: flex;
  align-items: baseline;
  gap: 8px;
  line-height: 1;
  white-space: nowrap;
}

#price-template--19541872869615__main .sticky-inline {
  display: none;
  align-items: center;
  gap: 12px;
  line-height: 1;
  font-weight: 700;
  white-space: nowrap;
}

#price-template--19541872869615__main .sticky-inline .price-label { 
  margin-right: 4px;
  color: #0E0B0D !important;
}

#price-template--19541872869615__main.sticky-bottom .sticky-inline { 
  display: flex; 
}

#price-template--19541872869615__main.sticky-bottom .price__container { 
  display: none !important; 
}



      /* Tooltip styles */
      .tooltip-icon {
        display: inline-block;
        margin-left: 6px;
        cursor: pointer;
        font-size: 14px;
        color: #9E5B63;
        font-weight: bold;
        position: relative;
      }
      .tooltip-popup {
        display: none;
        position: absolute;
        bottom: -40px;
        left: 0;
        background-color: white;
        border: 1px solid #ccc;
        padding: 10px 12px;
        font-size: 13px;
        white-space: nowrap;
        z-index: 9999;
        box-shadow: 0 2px 6px rgba(0,0,0,0.15);
      }
      .tooltip-popup a { text-decoration: none; color: #000; }
      .tooltip-popup a:hover { text-decoration: underline; }

      /* Touch device styles */
      .no-hover .tooltip-icon:hover .tooltip-popup { display: none !important; }

      /* Icon wrapper */
      .product-feature-icon-grid--wrapper .icon-wrapper {
        display: inline-flex;
        width: 32px;
        height: 32px;
        overflow: hidden;
        flex-shrink: 0;
      }
      .product-feature-icon-grid--wrapper .icon-wrapper img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .product-feature-icon-grid--wrapper .product-feature-icon-grid {
        list-style: none;
        padding: 8px 0;
        margin: 0 auto;
        max-width: 1000px;
      }

      /* Mobile styles */
      @media (max-width: 768px) {
        #price-template--19541872869615__main.sticky-bottom { justify-content: center !important; }
        #price-template--19541872869615__main.sticky-bottom .sticky-inline { 
          justify-content: center !important; 
          width: 100% !important; 
          text-align: center !important; 
        }
        .product-feature-icon-grid--wrapper .product-feature-icon-grid {
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 20px 15px;
        }
        .product-feature-icon-grid--wrapper .product-feature-icon--item {
          position: static;
          padding: 0;
          text-align: center;
        }
        .product-feature-icon-grid--wrapper .product-feature-icon--item::after {
          display: none !important;
          content: none !important;
        }
        .card-product--badges {
          position: relative !important;
          display: flex !important;
          justify-content: center !important;
          gap: 4px !important;
          margin-top: 6px !important;
        }
        .badge-ready {
          background-color: #F1E3E5 !important;
          color: #9E5B63 !important;
          font-weight: 700 !important;
          font-size: 1.1rem !important;
          text-transform: none !important;
          padding: 8px !important;
          border-radius: 0 !important;
          display: inline-block !important;
        }
        .badge-bf {
          background-color: #9E5B63 !important;
          color: #ffffff !important;
          border: 2px solid #9E5B63 !important;
          font-weight: 700 !important;
          font-size: 1rem !important;
          text-transform: uppercase !important;
          padding: 8px !important;
          border-radius: 0 !important;
          display: inline-block !important;
        }
      }

      /* Desktop icon grid */
      @media (min-width: 769px) {
        .product-feature-icon-grid--wrapper .product-feature-icon-grid {
          display: flex !important;
          justify-content: space-between;
          align-items: center;
        }
        .product-feature-icon-grid--wrapper .product-feature-icon--item {
          flex: 1 1 0%;
          text-align: center;
          padding: 0 10px;
          position: relative;
        }
        .product-feature-icon-grid--wrapper .product-feature-icon--item:not(:last-child)::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 24px;
          width: 1px;
          background: #ddd;
        }
      }

      /* Cart page styles */
      .discounts__discount {
        display: inline-block;
        border: 1.5px solid #9E5B63;
        border-radius: 6px;
        padding: 4px 10px;
        font-size: 0.9em;
        color: #0E102F;
        background: #F9F8F6;
        font-weight: 500;
        margin-top: 6px;
        margin-right: 6px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
      }
      .free-resizing-badge {
        border: 1px solid #9E5B63 !important;
        background: #FBFAF8 !important;
        font-weight: 600 !important;
      }

      /* Custom modal */
      .custom-modal {
        display: none;
        position: fixed;
        z-index: 9999;
        inset: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        justify-content: center;
        align-items: center;
      }
      .custom-modal-content {
        background: #fff;
        padding: 20px 25px;
        border-radius: 8px;
        max-width: 480px;
        width: 90%;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        text-align: center;
        position: relative;
        animation: fadeInUp .3s ease;
      }
      .custom-modal-close {
        position: absolute;
        right: 12px;
        top: 8px;
        font-size: 22px;
        font-weight: bold;
        color: #666;
        cursor: pointer;
        background: none;
        border: 0;
      }
      @keyframes fadeInUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // ============================================
  // PRICE "FROM" PREFIX HANDLER
  // ============================================
  
  const PriceManager = {
    init() {
      if (isReadyToShip()) {
        document.querySelectorAll('.with-from').forEach(el => el.classList.remove('with-from'));
        return;
      }
      this.updateAllPrices();
    },

    isVisible(el) {
      if (!el) return false;
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      return el.getClientRects().length > 0;
    },

    getActivePriceEl(card) {
      let el = card.querySelector(CONFIG.selectors.salePrice);
      if (!this.isVisible(el)) el = null;
      if (!el) {
        el = card.querySelector(CONFIG.selectors.regularPrice);
        if (!this.isVisible(el)) el = null;
      }
      return el || card.querySelector(CONFIG.selectors.salePrice) || 
             card.querySelector(CONFIG.selectors.regularPrice) || 
             card.querySelector('.spf-product-card__price');
    },

    normalizePriceEl(el) {
      if (!el) return;
      const txt = (el.textContent || '').replace(/^\s*From\s+/i, '').trim();
      if (txt !== el.textContent.trim()) el.textContent = txt;
      el.classList.add(CONFIG.classes.withFrom);
    },

    updateAllPrices() {
      const cards = document.querySelectorAll(CONFIG.selectors.productCard);
      cards.forEach(card => this.normalizePriceEl(this.getActivePriceEl(card)));
    }
  };

  // ============================================
  // CUSTOMIZE/DETAILS BUTTON HANDLER
  // ============================================
  
  const ButtonManager = {
    processed: new WeakSet(),

    init() {
      // Only run on collection pages, NOT on PDPs
      if (this.isPDP()) return;
      this.updateAllButtons();
    },

    isPDP() {
      // Check if we're on a Product Detail Page
      return !!(
        document.querySelector("form[action*='/cart/add']") ||
        document.querySelector(".product-form") ||
        document.querySelector(".product__info-container") ||
        document.querySelector('meta[property="og:type"][content="product"]')
      );
    },

    isInStickyBar(element) {
      // Check if element is inside sticky price bar
      return !!(
        element.closest('#price-template--19541872869615__main') ||
        element.closest('.sticky-bottom') ||
        element.closest('.product__info-wrapper')
      );
    },

    addCustomizeButton(priceContainer) {
      // Skip if already processed
      if (this.processed.has(priceContainer)) return;
      
      // Skip if already has wrapper
      if (priceContainer.parentElement.classList.contains('price-flex-wrapper')) return;

      // Skip if on PDP
      if (this.isPDP()) return;

      // Skip if in sticky bar or product info section
      if (this.isInStickyBar(priceContainer)) return;

      // Skip if not in a product card
      const card = priceContainer.closest('.card, .spf-product-card, .product-card');
      if (!card) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'price-flex-wrapper';

      const btn = document.createElement('button');
      btn.className = 'customize-button';
      btn.textContent = isReadyToShip() ? 'Details' : 'Customize';

      priceContainer.parentNode.insertBefore(wrapper, priceContainer);
      wrapper.appendChild(priceContainer);
      wrapper.appendChild(btn);

      this.processed.add(priceContainer);
    },

    convertToDetailsButton(card) {
      const isReady = !!card.querySelector(CONFIG.selectors.readyBadge);
      const btn = card.querySelector(CONFIG.selectors.customizeButton);
      
      if (!btn || btn.matches('a.details-button')) return;

      if (isReady) {
        const linkEl = card.querySelector('.card-media a, .card-product--text-section-link');
        const href = linkEl ? linkEl.getAttribute('href') : '#';

        const a = document.createElement('a');
        a.className = btn.className + ' details-button';
        a.textContent = 'Details';
        a.href = href;
        a.setAttribute('role', 'button');
        a.setAttribute('aria-label', 'View details');

        btn.replaceWith(a);
      } else {
        if (btn.textContent.trim() !== 'Customize') btn.textContent = 'Customize';
        btn.type = 'button';
      }
    },

    updateAllButtons() {
      // Only run on collection pages
      if (this.isPDP()) return;

      // Add customize buttons only to product cards on collection pages
      document.querySelectorAll(CONFIG.selectors.priceContainer).forEach(pc => {
        this.addCustomizeButton(pc);
      });

      // Convert to details for ready-to-ship
      document.querySelectorAll('.featured-collection-section .card.card-product').forEach(card => {
        this.convertToDetailsButton(card);
      });
    }
  };

  // ============================================
  // STICKY PRICE BAR HANDLER
  // ============================================
  
  const StickyPriceBar = {
    priceBlock: null,
    stickyRow: null,

    init() {
      this.priceBlock = document.querySelector(CONFIG.selectors.priceBlock);
      if (!this.priceBlock) return;

      this.ensureStickyInline();
      this.handleScroll();
      window.addEventListener('scroll', throttle(() => this.handleScroll(), 100), { passive: true });

      // Watch for price changes
      const target = this.priceBlock.querySelector(CONFIG.selectors.priceContainer) || this.priceBlock;
      const mo = new MutationObserver(() => {
        if (this.priceBlock.classList.contains(CONFIG.classes.stickyBottom)) {
          this.renderStickyAmount();
        }
      });
      mo.observe(target, { subtree: true, childList: true, characterData: true });
    },

//     ensureStickyInline() {
//   this.stickyRow = this.priceBlock.querySelector(`.${CONFIG.classes.stickyInline}`);
//   if (!this.stickyRow) {
//     const price = this.priceBlock.querySelector('.price');
//     this.stickyRow = document.createElement('div');
//     this.stickyRow.className = CONFIG.classes.stickyInline;

//     // Add deposit notice (left side)
//     const depositNotice = document.createElement('span');
//     depositNotice.className = 'deposit-notice';
//     depositNotice.textContent = '25% will be applied in cart';
//     depositNotice.style.marginRight = '12px';
//     depositNotice.style.fontSize = '14px';
//     depositNotice.style.fontWeight = '400';
//     depositNotice.style.color = '#666';

//     const label = document.createElement('span');
//     label.className = 'price-label';
//     label.textContent = 'Total Price:';

//     const amount = document.createElement('span');
//     amount.className = 'price-inline-amount';

//     // Append in order: deposit notice, label, amount
//     this.stickyRow.appendChild(depositNotice);
//     this.stickyRow.appendChild(label);
//     this.stickyRow.appendChild(amount);

//     if (price) price.prepend(this.stickyRow);
//     else this.priceBlock.prepend(this.stickyRow);
//   }
//   return this.stickyRow;
// },

ensureStickyInline() {
  this.stickyRow = this.priceBlock.querySelector(`.${CONFIG.classes.stickyInline}`);
  if (!this.stickyRow) {
    const price = this.priceBlock.querySelector('.price');
    this.stickyRow = document.createElement('div');
    this.stickyRow.className = CONFIG.classes.stickyInline;

    const label = document.createElement('span');
    label.className = 'price-label';
    label.textContent = 'Total Price:';

    const amount = document.createElement('span');
    amount.className = 'price-inline-amount';

    // Append in order: label, amount
    this.stickyRow.appendChild(label);
    this.stickyRow.appendChild(amount);

    if (price) price.prepend(this.stickyRow);
    else this.priceBlock.prepend(this.stickyRow);
  }
  return this.stickyRow;
},

    computeAmount() {
      const container = this.priceBlock.querySelector(CONFIG.selectors.priceContainer);
      if (!container) return '';

      const regEl = this.priceBlock.querySelector(CONFIG.selectors.regularPrice);
      const saleEl = this.priceBlock.querySelector(CONFIG.selectors.salePrice);
      const cmpEl = this.priceBlock.querySelector('.price__sale .price-item--regular');

      const getTxt = el => (el && el.textContent || '').replace(/\s+/g, ' ').trim();
      const regTxt = getTxt(regEl);
      const saleTxt = getTxt(saleEl);
      const cmpTxt = getTxt(cmpEl);

      const realSale = !!cmpTxt && !!saleTxt && cmpTxt !== saleTxt;
      const hasFrom = regEl && regEl.classList.contains(CONFIG.classes.withFrom);

      const cleanAmount = (realSale ? saleTxt : regTxt).replace(/\s?USD$/i, '');
      return (hasFrom ? 'from ' : '') + cleanAmount;
    },

    renderStickyAmount() {
      const row = this.ensureStickyInline();
      const amount = row.querySelector('.price-inline-amount');
      const newText = this.computeAmount();
      if (amount && newText) amount.textContent = newText;
    },

    handleScroll() {
      const y = window.scrollY || window.pageYOffset;
      const shouldStick = (isMobile() && y > 450) || (!isMobile() && y > 240);

      this.priceBlock.classList.toggle(CONFIG.classes.stickyBottom, shouldStick);
      if (shouldStick) this.renderStickyAmount();
    }
  };

  // ============================================
  // CART PAGE HANDLER
  // ============================================
  
  const CartManager = {
    init() {
      if (!isCartPage()) return;

      this.hideDiscountedPrices();
      this.stylePrices();
      this.styleDiscountBadges();
      this.insertResizingBadges();
      this.renameDiscountLabels();
    },

    hideDiscountedPrices() {
      document.querySelectorAll('.cart-item__details .cart-item__discounted-prices')
        .forEach(el => el.style.display = 'none');
    },

    stylePrices() {
      document.querySelectorAll('.cart-item__discounted-prices').forEach(block => {
        const sale = block.querySelector('.price--end:not(.cart-item__old-price)');
        const old = block.querySelector('.cart-item__old-price');

        if (sale) sale.removeAttribute('style');
        if (old) old.removeAttribute('style');

        if (sale && sale.textContent.trim() !== '') {
          Object.assign(sale.style, {
            color: '#0E102F',
            fontWeight: '700',
            fontSize: '1.1em',
            border: '1.5px solid #85745C',
            borderRadius: '6px',
            padding: '3px 8px',
            display: 'inline-block',
            background: '#F9F8F6'
          });
        } else if (old) {
          Object.assign(old.style, {
            color: '#0E102F',
            fontWeight: '700',
            fontSize: '1.1em',
            border: '1.5px solid #85745C',
            borderRadius: '6px',
            padding: '3px 8px',
            display: 'inline-block',
            background: '#F9F8F6',
            textDecoration: 'none'
          });
        }

        if (old && sale && sale.textContent.trim() !== '') {
          Object.assign(old.style, {
            color: '#9A9A9A',
            opacity: '0.6',
            textDecoration: 'line-through',
            marginRight: '8px',
            fontWeight: '400'
          });
        }
      });
    },

    styleDiscountBadges() {
      document.querySelectorAll('.discounts__discount').forEach(el => {
        Object.assign(el.style, {
          display: 'inline-block',
          border: '1.5px solid #9E5B63',
          borderRadius: '6px',
          padding: '4px 10px',
          fontSize: '0.9em',
          color: '#0E102F',
          background: '#F9F8F6',
          fontWeight: '500',
          marginTop: '6px',
          marginRight: '6px',
          textTransform: 'uppercase',
          letterSpacing: '0.03em'
        });
      });

      document.querySelectorAll(`.${CONFIG.classes.freeResizingBadge}`).forEach(el => {
        Object.assign(el.style, {
          border: '1px solid #9E5B63',
          background: '#FBFAF8',
          fontWeight: '600'
        });
      });
    },

    insertResizingBadges() {
      const cartItems = document.querySelectorAll(CONFIG.selectors.cartItem);

      cartItems.forEach(item => {
        const title = item.querySelector('.cart-item__product-title');
        if (!title) return;

        const titleText = title.textContent.toLowerCase();
        const hasBadge = item.querySelector(`.${CONFIG.classes.freeResizingBadge}`);

        if ((titleText.includes('ring') || titleText.includes('band')) && !hasBadge) {
          const badge = document.createElement('li');
          badge.className = `discounts__discount ${CONFIG.classes.freeResizingBadge}`;
          badge.textContent = 'FREE Resizing – 1st year';

          const wrapper = document.createElement('ul');
          wrapper.className = 'discounts list-unstyled';
          wrapper.setAttribute('role', 'list');
          wrapper.setAttribute('aria-label', 'Extra info');
          wrapper.appendChild(badge);

          const discountList = item.querySelector('.discounts');
          if (discountList && discountList.nextSibling) {
            discountList.parentNode.insertBefore(wrapper, discountList.nextSibling);
          } else if (discountList) {
            discountList.insertAdjacentElement('afterend', wrapper);
          } else {
            item.appendChild(wrapper);
          }
        }
      });
    },

    renameDiscountLabels() {
      // Change "Black Friday" to "Holiday Deal" in cart
      const renameLabels = () => {
        // Target all discount labels in cart
        const discountElements = document.querySelectorAll(
          '.cart-item__discounts .discounts__discount, ' +
          '.discounts__discount, ' +
          '.cart__discount, ' +
          '.cart-item__details .discounts li, ' +
          '[class*="discount"]'
        );

        discountElements.forEach(el => {
          // Check if it contains "Black Friday" (case insensitive)
          if (el.textContent && /black\s*friday/i.test(el.textContent)) {
            // Preserve the element's classes and styling
            el.textContent = el.textContent.replace(/black\s*friday/gi, 'Holiday Deal');
            
            // Ensure it has the proper discount styling class
            if (!el.classList.contains('discounts__discount')) {
              el.classList.add('discounts__discount');
            }
            
            // Apply inline styles to ensure visibility
            el.style.display = 'inline-block';
            el.style.border = '1.5px solid #85745C';
            el.style.borderRadius = '6px';
            el.style.padding = '4px 10px';
            el.style.fontSize = '0.9em';
            el.style.color = '#0E102F';
            el.style.background = '#F9F8F6';
            el.style.fontWeight = '500';
            el.style.marginTop = '6px';
            el.style.marginRight = '6px';
            el.style.textTransform = 'uppercase';
            el.style.letterSpacing = '0.03em';
          }
        });

        // Also check cart drawer
        const drawerDiscounts = document.querySelectorAll(
          '.cart-drawer .discounts__discount, ' +
          '.drawer__contents .discounts__discount, ' +
          '.cart-drawer .discounts li'
        );

        drawerDiscounts.forEach(el => {
          if (el.textContent && /black\s*friday/i.test(el.textContent)) {
            el.textContent = el.textContent.replace(/black\s*friday/gi, 'Holiday Deal');
            
            // Ensure proper styling
            if (!el.classList.contains('discounts__discount')) {
              el.classList.add('discounts__discount');
            }
            
            // Apply inline styles
            el.style.display = 'inline-block';
            el.style.border = '1.5px solid #85745C';
            el.style.borderRadius = '6px';
            el.style.padding = '4px 10px';
            el.style.fontSize = '0.9em';
            el.style.color = '#0E102F';
            el.style.background = '#F9F8F6';
            el.style.fontWeight = '500';
            el.style.marginTop = '6px';
            el.style.marginRight = '6px';
            el.style.textTransform = 'uppercase';
            el.style.letterSpacing = '0.03em';
          }
        });
      };

      // Run immediately
      renameLabels();

      // Run after delay (for dynamic loading)
      setTimeout(renameLabels, 500);
      setTimeout(renameLabels, 1000);
      setTimeout(renameLabels, 1500);

      // Watch for cart updates
      const observer = new MutationObserver(debounce(renameLabels, 100));
      observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        characterData: true 
      });

      // Listen for cart events
      document.addEventListener('cart:updated', renameLabels);
      document.addEventListener('shopify:section:load', renameLabels);
    }
  };

  // ============================================
  // TOOLTIP HANDLER
  // ============================================
  
  const TooltipManager = {
    tooltipData: [
      {
        labelText: 'Metal',
        linkHref: 'https://asseldiamonds.com/pages/education#metal',
        linkText: 'Learn more about metals →'
      },
      {
        labelText: 'Diamond Shape',
        linkHref: 'https://asseldiamonds.com/pages/education#diamond-shape',
        linkText: 'Explore diamond shapes →'
      },
      {
        labelText: 'Diamond Color',
        linkHref: 'https://asseldiamonds.com/pages/education#diamond-color',
        linkText: 'Understand diamond color →'
      },
      {
        labelText: 'Diamond Clarity',
        linkHref: 'https://asseldiamonds.com/pages/education#diamond-clarity',
        linkText: 'Explore clarity grades →'
      },
      {
        labelText: 'Diamond Carat',
        linkHref: 'https://asseldiamonds.com/pages/education#diamond-carat',
        linkText: 'Learn about carat weights →'
      }
    ],

    init() {
      this.tooltipData.forEach(item => this.addTooltip(item));
    },

    addTooltip(item) {
      const label = Array.from(document.querySelectorAll('.mpg-swatch__label-option, legend span, legend label, legend, .product-form__input legend, .mw-label .mw-text--style-strong'))
        .find(el => el.textContent.trim().replace(/[:*]/g, '') === item.labelText);
      
      if (!label) return;

      const container = label.closest('legend') || label.closest('.product-form__input legend') || 
                       label.closest('label') || label.parentElement.closest('.mw-stack__item') || 
                       label.parentElement;
      
      if (!container || container.querySelector('.tooltip-icon')) return;

      const icon = document.createElement('span');
      icon.className = 'tooltip-icon';
      icon.innerHTML = '&#9432;';
      container.appendChild(icon);

      const popup = document.createElement('div');
      popup.className = 'tooltip-popup';
      popup.innerHTML = `<a href="${item.linkHref}" target="_blank">${item.linkText}</a>`;
      icon.appendChild(popup);

      let hoverTimeout;
      icon.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        popup.style.display = 'block';
      });
      icon.addEventListener('mouseleave', () => {
        hoverTimeout = setTimeout(() => {
          if (!popup.matches(':hover')) popup.style.display = 'none';
        }, 200);
      });
      popup.addEventListener('mouseleave', () => popup.style.display = 'none');
      popup.addEventListener('mouseenter', () => clearTimeout(hoverTimeout));
    }
  };

  // ============================================
  // TOUCH DEVICE HANDLER
  // ============================================
  
  const TouchHandler = {
    lastNavAt: 0,

    init() {
      window.addEventListener('touchstart', function onFirstTouch() {
        document.documentElement.classList.add(CONFIG.classes.noHover);
        window.removeEventListener('touchstart', onFirstTouch, { passive: true });
      }, { passive: true });

      document.addEventListener('pointerup', (e) => {
        if (e.pointerType === 'touch' || e.pointerType === 'pen') {
          this.tryNavigate(e);
        }
      }, true);

      document.addEventListener('click', (e) => this.tryNavigate(e), true);
    },

    getHandle(el) {
      const oc = el.getAttribute('onclick') || '';
      const m = oc.match(/mpg\.redirectToProductPage\(\s*['"]([^'"]+)['"]\s*\)/);
      return m ? m[1] : null;
    },

    go(handle) {
      if (!handle) return;
      if (window.mpg && typeof window.mpg.redirectToProductPage === 'function') {
        window.mpg.redirectToProductPage(handle);
      } else {
        const url = handle.startsWith('/') || handle.startsWith('http') ? handle : ('/' + handle);
        window.location.assign(url);
      }
    },

    tryNavigate(e) {
      const swatch = e.target.closest('.mpg-swatch__option[onclick]');
      if (!swatch) return false;

      const now = Date.now();
      if (now - this.lastNavAt < 800) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return true;
      }

      const handle = this.getHandle(swatch);
      if (!handle) return false;

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      this.lastNavAt = now;
      this.go(handle);
      return true;
    }
  };

  // ============================================
  // THIRD-PARTY INTEGRATIONS
  // ============================================
  
  const ThirdPartyManager = {
    init() {
      this.fixTidioChat();
      this.fixAvadaButtons();
      this.fixFaqIcons();
      this.fixDeliveryIcons();
      this.setupModal();
      this.hideAffirmInCartDrawer();
    },

    fixTidioChat() {
      const checkTidio = () => {
        const button = document.querySelector(CONFIG.selectors.tidioButton);
        if (button) {
          button.style.marginBottom = '3rem';
          clearInterval(tidioInterval);
        }

        const tidio = document.querySelector(CONFIG.selectors.tidioChat);
        if (tidio) {
          tidio.style.bottom = isMobile() ? '55px' : '18px';
          clearInterval(tidioInterval);
        }
      };

      const tidioInterval = setInterval(checkTidio, 300);
      setTimeout(() => clearInterval(tidioInterval), 5000);
    },

    fixAvadaButtons() {
      if (!isMobile()) return;

      const fix = () => {
        document.querySelectorAll(CONFIG.selectors.avadaButton).forEach(el => {
          el.style.setProperty('border-radius', '0.15rem', 'important');
        });

        document.querySelectorAll('.Avada-Faqs_Button.bottom.right').forEach(el => {
          el.style.setProperty('bottom', '72px', 'important');
          el.style.setProperty('right', '5px', 'important');
        });
      };

      fix();
      setTimeout(fix, 150);
      setTimeout(fix, 400);
      setTimeout(fix, 800);

      const mo = new MutationObserver(debounce(fix, 150));
      mo.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    },

    fixFaqIcons() {
      const fix = () => {
        document.querySelectorAll(CONFIG.selectors.faqIcons).forEach(icon => {
          icon.style.borderRadius = '5px';
          const inner = icon.querySelector('div');
          if (inner) inner.style.borderRadius = '5px';
        });
      };

      fix();
      const mo = new MutationObserver(debounce(fix, 100));
      mo.observe(document.body, { childList: true, subtree: true });
    },

    fixDeliveryIcons() {
      if (!isMobile()) return;

      const fix = () => {
        document.querySelectorAll(CONFIG.selectors.deliveryIcon).forEach(icon => {
          Object.assign(icon.style, {
            width: '16px',
            height: '16px',
            maxWidth: '16px',
            maxHeight: '16px',
            objectFit: 'contain',
            display: 'inline-block'
          });
        });

        document.querySelectorAll('.delivery-christmas').forEach(el => {
          Object.assign(el.style, {
            fontSize: '16px',
            gap: '5px',
            alignItems: 'center',
            display: 'inline-flex'
          });
        });
      };

      fix();
      setTimeout(fix, 300);
      setTimeout(fix, 800);
    },

    setupModal() {
      const modal = document.getElementById('affordable-diamonds-modal');
      const trigger = document.getElementById('affordable-diamonds-trigger');
      if (!trigger || !modal) return;

      const closeBtn = modal.querySelector('.custom-modal-close');

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        modal.style.display = 'flex';
      });

      closeBtn.addEventListener('click', () => modal.style.display = 'none');
      window.addEventListener('click', (e) => {
        if (e.target === modal) modal.style.display = 'none';
      });
    },

    hideAffirmInCartDrawer() {
      // Hide Affirm messaging in cart drawer
      const hideAffirm = () => {
        // Target Affirm in cart drawer footer
        const affirmElements = document.querySelectorAll(
          '.cart-drawer__footer .affirm-as-low-as, ' +
          '.cart-drawer .affirm-as-low-as, ' +
          '[data-affirm-type="logo"][data-page-type="cart"]'
        );

        affirmElements.forEach(el => {
          el.style.display = 'none';
        });
      };

      // Run immediately
      hideAffirm();

      // Run after short delay (Affirm loads async)
      setTimeout(hideAffirm, 500);
      setTimeout(hideAffirm, 1000);
      setTimeout(hideAffirm, 2000);

      // Watch for cart drawer opening/updates
      const observer = new MutationObserver(debounce(hideAffirm, 100));
      
      // Observe cart drawer if it exists
      const cartDrawer = document.querySelector('.cart-drawer, #cart-drawer, [id*="drawer"]');
      if (cartDrawer) {
        observer.observe(cartDrawer, {
          childList: true,
          subtree: true
        });
      }

      // Also listen for Shopify cart events
      document.addEventListener('cart:updated', hideAffirm);
      document.addEventListener('shopify:section:load', hideAffirm);
    }
  };

  // ============================================
  // PAGE-SPECIFIC HANDLERS
  // ============================================
  
  const PageSpecific = {
    init() {
      this.handleEducationPage();
      this.handleHomePage();
      this.handleCollectionGrid();
      this.handleRingSizer();
    },

    handleEducationPage() {
      if (!isEducationPage()) return;

      const setId = (headingText, id) => {
        document.querySelectorAll('.h2, h2').forEach(h => {
          if (h.textContent.trim().includes(headingText)) {
            const container = h.closest('.image-with-text--text');
            if (container) container.id = id;
          }
        });
      };

      setId('What Does "Diamond Color" Actually Mean?', 'diamond-color');
      setId('Diamond Clarity', 'diamond-clarity');
      setId('Diamond Carat', 'diamond-carat');
      setId('Diamond Cut', 'diamond-cut');
    },

    handleHomePage() {
      const img = document.querySelector('.section-template--19541872967919__image_banner_hjV4hw .banner-primary-image img');
      if (img) {
        img.style.webkitFilter = 'blur(12px)';
        img.style.filter = 'blur(12px)';
        img.style.transform = 'scale(1.05)';
      }
    },

    handleCollectionGrid() {
      if (!isMobile()) return;

      const grid = document.getElementById('product-grid');
      if (grid) {
        grid.style.display = 'grid';
        grid.style.gridTemplateColumns = 'repeat(2, minmax(0,1fr))';
        grid.style.columnGap = '16px';
        grid.style.rowGap = '24px';
        grid.querySelectorAll('.grid__item').forEach(li => {
          Object.assign(li.style, {
            width: 'auto',
            maxWidth: 'none',
            flex: 'initial',
            margin: '0'
          });
        });
      }
    },

    handleRingSizer() {
      const ringSizer = document.querySelector('.product__text.product-text-text_TihhPT');
      if (ringSizer) {
        ringSizer.style.position = 'relative';
        ringSizer.style.top = '-18px';
      }
    }
  };

  // ============================================
  // UNIFIED DOM OBSERVER
  // ============================================
  
  const DOMObserver = {
    observer: null,
    updateQueue: new Set(),
    rafId: null,

    init() {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              this.updateQueue.add(node);
            }
          });
        });
        this.scheduleUpdate();
      });

      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    },

    scheduleUpdate() {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(() => {
        this.processQueue();
        this.rafId = null;
      });
    },

    processQueue() {
      if (this.updateQueue.size === 0) return;

      // Process updates
      PriceManager.updateAllPrices();
      ButtonManager.updateAllButtons();
      TooltipManager.init();
      
      if (isCartPage()) {
        CartManager.init();
      }

      this.updateQueue.clear();
    }
  };

  // ============================================
  // ERROR SUPPRESSION
  // ============================================
  
  function suppressKiteErrors() {
    window.addEventListener('error', function(e) {
      if (e.message && e.message.includes('is not valid JSON')) {
        e.stopImmediatePropagation();
        console.warn('Kite JSON error suppressed');
      }
    }, true);
  }

  // ============================================
  // MAIN INITIALIZATION
  // ============================================
  
  function init() {
    // Inject styles first
    injectStyles();

    // Initialize all managers
    PriceManager.init();
    ButtonManager.init();
    StickyPriceBar.init();
    CartManager.init();
    TooltipManager.init();
    TouchHandler.init();
    ThirdPartyManager.init();
    PageSpecific.init();
    DOMObserver.init();
    suppressKiteErrors();

    // Listen for Shopify events
    ['cart:updated', 'shopify:section:load', 'shopify:section:select', 'shopify:section:deselect']
      .forEach(evt => {
        document.addEventListener(evt, debounce(() => {
          PriceManager.updateAllPrices();
          ButtonManager.updateAllButtons();
          if (isCartPage()) CartManager.init();
        }, 100));
      });

    // Handle swatch clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest(CONFIG.selectors.swatch)) {
        requestAnimationFrame(() => {
          PriceManager.updateAllPrices();
          ButtonManager.updateAllButtons();
        });
      }
    });

    // Handle resize
    window.addEventListener('resize', debounce(() => {
      ThirdPartyManager.fixTidioChat();
      ThirdPartyManager.fixAvadaButtons();
      PageSpecific.handleCollectionGrid();
    }, 250));
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();